<template>
  <div id="app" class="app">
    <div class="top">
      <div class="logo">
        <i class="logo_icon"></i>
        <span>绿叶工具箱</span>
      </div>
      <!-- <a href="https://www.apple.com/cn/itunes/charts/" class="download_btn">立即下载</a> -->
    </div>
    <div class="model_body">
      <div class="model">
        <h3>功能展示</h3>
        <div class="swiper">
          <ul class="img_list">
            <li class="img_item" v-for="(item, index) in imgList" :key="index">
              <img :src="item.url">
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="model model-award">
        <h3><i class="model_icon"></i>所获荣誉</h3>
        <p><span>【2015年】</span>荣获由工信部指导，中国手机产业协会主办，国际移动通信联合会等协办的中国手机产业年会“年度最佳手机应用”大奖；</p>
        <p><span>【2016年】</span>荣获由艾媒咨询集团主办的第七届中国移动互联网 “最佳创新工具应用”大奖；</p>
        <p><span>【2018年】</span>荣获软件绿色联盟颁发的“实用工具”类绿色应用大奖；</p>
      </div> -->
      <div class="model">
        <h3>内容摘要</h3>
        <p>绿叶工具箱是一款支持图片编辑及照片、视频、文件云端存储的APP，是微商，销售，商务等社交达人手机必备实用小工具之一。</p>
      </div>
      <div class="model">
        <span>【产品功能】</span>
        <span>图片编辑：支持图片添加水印，马赛克及裁剪图片尺寸，操作简单好用。</span>
        <span>云端照片：支持照片保存在云端，从此告别手机空间不足、照片丢失的困扰。</span>
        <span>云端视频：支持视频保存在云端，节省本机空间，随时随地观看自己珍藏的精彩视频。</span>
        <span>云文件夹：支持各类文件一键下载本机、上传云端、远程删除，实用方便。</span>
      </div>
      <div class="model">
        <p>现在快和你的小伙伴一起来享受绿叶工具箱带来的便捷吧！</p>
      </div>
      <!-- <div class="model">
        <span style="padding-left:.5em">意见反馈</span>
        <p>如遇问题或者有好的建议，欢迎加入双开助手用户QQ群（859309868），向客服反馈！</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },
  data () {
    return {
      imgList: [{
        url: require('./assets/2.jpg')
      }, {
        url: require('./assets/3.jpg')
      }, {
        url: require('./assets/5.jpg')
      }, {
        url: require('./assets/1.jpg')
      }, {
        url: require('./assets/4.jpg')
      }]
    }
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background: no-repeat 0 0;
  background-size: 100% auto;
  font-size: inherit;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  line-height: inherit;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
html {
  font-size: 12px;
}
body {
  height: auto;
  -webkit-user-select: none;
  user-select: none;
  background-color: #ffffff
}
li {
    list-style: none;
}
button {
    outline: none;
}
a {
  text-decoration: none;
  color: inherit;
}
#app {
  width: 100%;
  font-family: -apple-system-font,
  BlinkMacSystemFont,
  "Helvetica Neue",
  "PingFang SC",
  "Hiragino Sans GB",
  "Microsoft YaHei UI",
  "Microsoft YaHei",
  Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
}
.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2em 0 1em;
}
.logo_icon {
  border: 1px solid #eee;
  width: 5em;
  height: 5em;
  background-image: url('./assets/logo.png');
  background-size: 86% auto;
  background-position: center;
  border-radius: .8em;
}
.logo span {
  color: #323232;
  font-size: 1.2em;
  font-weight: 500;
  line-height: 2.2em;
}
.download_btn {
  display: block;
  font-size: 1.2em;
  color: #fff;
  width: 70%;
  height: 2em;
  line-height: 2em;
  border-radius: 2em;
  margin: 0 auto;
  text-align: center;
  background-color: rgb(75, 116, 200)
}
.model_body {
  padding: 0 4% 2em;
}
.model {
  margin-bottom: 1.6em;
}
.model h3 {
  font-size: 1.1em;
  font-weight: 500;
  line-height: 3em;
  color: rgb(34, 34, 34);
  display: flex;
  align-items: center;
}
.model p{
  font-size: .95em;
  line-height: 1.8em;
  letter-spacing: 1px;
  color: #777;
  text-align: justify;
  margin-bottom: 1em;
}
.model-award p{
  margin-bottom: 0;
  text-indent: -.5em;
}
.model p span {
  color: rgb(75, 116, 200);
}
.model > span {
  display: block;
  color: #777;
  font-size: .95em;
  line-height: 1.8em;
}
.model > span:first-child {
  text-indent: -.5em;
}
.model_icon {
  width: 1em;
  height: 3em;
  background-image: url('./assets/award.png');
  background-position-y: .86em;
  margin-right: .2em;
}
.swiper {
  white-space: nowrap;
  overflow-x: auto;
}
.img_item {
  display: inline-block;
  width: 16em;
  margin-right: .6em;
}
.img_item img {
  width: 100%;
  border-radius: 6px;
}
</style>
